
import { AgGridReact } from 'ag-grid-react'

import React from 'react'
import { useAlert } from 'react-alert'
import { Error, Header, Loader } from '../components'
import { useStateContext } from '../contexts/ContextProvider'
import { useGetPassesQuery } from '../redux/passes/passApi'

//icons
import { RiMotorbikeFill } from 'react-icons/ri'
import { FaCarSide, FaTruck } from 'react-icons/fa'
import { AiOutlineQuestionCircle } from 'react-icons/ai'




const CellRenderer = p => {
    let date = new Date(p.value)
    return <p>{date.toLocaleDateString()}</p>
}
const ExpireRenderer = p => {
    let date = new Date(p.value)
    date.setDate(date.getDate() + 7);
    return <p>{date.toLocaleDateString()}</p>
}
const VehicleRenderer = p => {
    const { currentColor } = useStateContext()
    let content = p.value;
    switch (p.value) {
        case 'bike':
            content = <div title='pass for bike' className='flex-row flex'>{Array(3).fill(<RiMotorbikeFill style={{ color: `${currentColor}` }} />)}</div>
            break;
        case 'car':
            content = <div title='pass for car' className='flex-row flex'>{Array(3).fill(<FaCarSide style={{ color: `${currentColor}` }} />)}</div>

            break;
        case 'truck':
            content = <div title='pass for truck' className='flex-row flex'>{Array(3).fill(<FaTruck style={{ color: `${currentColor}` }} />)}</div>

            break;
        case 'unknown':
            content = <div title='pass for unknown vehicle' className='flex-row flex'>{Array(3).fill(<AiOutlineQuestionCircle style={{ color: `${currentColor}` }} />)}</div>

            break;

        default:
            break;
    }
    return content;
}

const Passes = () => {

    const { data, isLoading, error } = useGetPassesQuery()
    const alert = useAlert()
    const { currentMode } = useStateContext()

    const defaultColDefs = {
        sortable: true, filter: true,
    }

    const columnsDefs = [
        { field: "status", headerName: "Status", flex: 1.5, },
        { field: "passFor", headerName: "Vehicle Type", flex: 2, cellRenderer: VehicleRenderer },
        { field: 'details', flex: 2 },
        { field: 'generatedOn', flex: 2, cellRenderer: CellRenderer, filter: null, sortable: null },
        { field: 'expireAt', flex: 2, cellRenderer: ExpireRenderer, filter: null, sortable: null },
        { field: 'user.name', headerName: "User", flex: 2 },
        { field: 'user.address.house', headerName: "🏠", flex: 1 },
        { field: 'user.address.street', headerName: "Street", flex: 1 },
        { field: 'user.address.block', headerName: "Block", flex: 1 },

    ]

    if (isLoading) return <Loader />

    if (error) {
        console.log("error is ", error)
        alert.show(error.data.message)
        alert.removeAll()
        return <Error />
    }



    return (
        <div className={`m-2 md:m-10 p-2 md:p-10 bg-white rounded-3xl ${currentMode === 'Dark' ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'} h-[500px]`}>
            <Header title="Passes 🚲🚗🚚 " category="Page" />

            <div className='h-[70%] w-[100%] ' style={{
            }}>
                <AgGridReact rowData={data.passes} columnDefs={columnsDefs} defaultColDef={defaultColDefs} animateRows={true} />
                {/* <button className=' px-3 py-1 border rounded-lg float-right mt-2 font-bold hover:text-white disabled:opacity-25 disabled:hover:text-black' style={{ backgroundColor: `${currentColor}` }} onClick={handler} disabled={complaintsToBeUpdated.length === 0}>update</button> */}
            </div>
        </div>
    )
}

export default Passes

